/*
 * @Author: vinc
 * @LastEditTime: 2020-09-23 11:43:55
 */
import Vue from 'vue'
import Vuex from 'vuex'
import $axios from './common/http';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        openTab: [],//所有打开的路由
        activeIndex: '', //激活状态
        name: '',
        purchaseNoList: '',
        token: '',
        shouldHideReturnFields: false, // 是否隐藏回款相关字段
        topLists: {
            requestList: [],
            platformList: [],
            serviceList: [],
            projectList: [],
            payList: [],
            financeList: [],
            approvalList: [],
            applicantList: [],
            requestListType1: [],
            requestListType4: [],
            businessNames:[]
        },
        dropdownList: {
            serviceList: [],
            companyInfoList: [],
            projectList: [],
            customerGroupList: [],
        },
    },
    mutations: {
        SET_TOKEN(state, res) {
            state.token = res;
        },
        // 添加tabs
        add_tabs(state, res) {
            state.openTab = res;
        },
        // 删除tabs
        delete_tabs(state, route) {
            let index = 0;
            for (let option of state.openTab) {
                if (option.route === route) {
                    break;
                }
                index++;
            }
            this.state.openTab.splice(index, 1);
            sessionStorage.setItem('GETONETAB', JSON.stringify(this.state.openTab));
        },
        // 设置当前激活的tab
        set_active_index(state, index) {
            state.activeIndex = index;
        },
        set_purchaseNoList(state, data) {
            state.purchaseNoList = data;
        },
        name(state) {
            state.name = sessionStorage.getItem('GETNAME');
        },
        SET_TOPLISTS(state, params) {
            state.topLists = { ...state.topLists, ...params }
        },
        SET_DROPDOWNLIST(state, params) {
            state.dropdownList = {...state.dropdownList, ...params};
        },
        SET_SHOULD_HIDE_RETURN_FIELDS(state, value) {
            state.shouldHideReturnFields = value;
        },
    },
    actions: {
        async getTopLists({ commit }, params) {
            let obj = {}
            let res = await $axios.post('/reqorder/financial/getsearchparam', { type: params });
            if (res.code == 200) {
                switch (params) {
                    case 1:
                        obj.platformList = res.result;
                        break;
                    case 3:
                        obj.requestList = res.result;
                        break;
                    case 4:
                        obj.projectList = res.result;
                        break;
                    case 7:
                        obj.financeList = res.result;
                        break;
                    case 10:
                        obj.approvalList = res.result;
                        break;
                    case 11:
                        obj.applicantList = res.result;
                        break;
                    case 13:
                        obj.refunderList = res.result;
                        break;
                    case 15:
                        obj.requestListType1 = res.result;
                        break;
                    case 17:
                        obj.requestListType4 = res.result;
                        break;
                    case 18:
                        obj.businessNames = res.result;
                        break;
                }
            }
            commit('SET_TOPLISTS', obj);
        },
        //getCompanyInfoList companyInfoList
        async getdropdownList({ commit }, params) {
            let dropdownList = {};
            let res = await $axios.post('/base/dropdown/search', {type:params});
            if (res.code == 200) {
                switch (params) {
                    case 2:
                        dropdownList.serviceList = res.result;
                        break;
                    case 4:
                        dropdownList.projectList = res.result;
                        break;
                    case 17:
                        dropdownList.companyInfoList = res.result;
                        break;
                    case 19:
                        // 集采项目下拉（编号-名称）
                        dropdownList.customerGroupList = res.result;
                        break;      
                }
            }
            commit('SET_DROPDOWNLIST', dropdownList);
        },
        set_name({ commit }, res) {
            sessionStorage.setItem('GETNAME', res);
        },
        set_tabs({ commit }, data) {
            if (this.state.openTab.indexOf(data) == -1) {
                this.state.openTab.push(data);
                sessionStorage.setItem('GETONETAB', JSON.stringify(this.state.openTab));
            }
        }
    }
})
